module.exports = __webpack_public_path__ + "static/media/collab.9cf4604c.jpg";